import request from "@/utils/request";

/**
 * 查询会员统计
 * @returns {AxiosPromise}
 */
export function getUsersStatis() {
  return request({
    url: "/report/getUsersStatis",
    method: "get",
    params: {}
  });
}

/**
 * 查询订单统计
 * @returns {AxiosPromise}
 */
export function getOrderStatis() {
  return request({
    url: "/report/getOrderStatis",
    method: "get",
    params: {}
  });
}

/**
 * 查询余额统计
 * @returns {AxiosPromise}
 */
export function getBalanceStatis() {
  return request({
    url: "/report/getBalanceStatis",
    method: "get",
    params: {}
  });
}
